module.exports = __webpack_public_path__ + "static/media/Entrance-1.ae9bb9aa.webp";